module.exports = __webpack_public_path__ + "static/kevin-880ccfec0c9da0aafd4c0103104a8b2e.jpg";